<template>
<svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M50.0007 91.6666C73.0125 91.6666 91.6673 73.0118 91.6673 49.9999C91.6673 26.9881 73.0125 8.33325 50.0007 8.33325C26.9888 8.33325 8.33398 26.9881 8.33398 49.9999C8.33398 73.0118 26.9888 91.6666 50.0007 91.6666Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M41.666 33.3333L66.666 49.9999L41.666 66.6666V33.3333Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
</template>
